import { j as o } from "../../../../jsx-runtime-p91LotPX.mjs";
import "../../../../GrowAvatar-DJSlhesM.mjs";
import "../../../Button/style.js";
import "../../../CheckBox/style.js";
import { GrowTypography as r } from "../../../Typography/AntTypography.js";
import "../../../utils/datetime-formatter.js";
import "../../../../core.esm-D9FG3ApV.mjs";
import "../../../../SortableItem-C--6XTJo.mjs";
import "../../../../lodash-lyheMOjd.mjs";
import "react";
import "../../../Dnd/SortableContainer.js";
import "../../../../style-ClHoikNh.mjs";
import "../../../../AntDrawer-ChgesM8B.mjs";
import "../../../../style-BCs5tvAM.mjs";
import "../../../StatusTag/style.js";
import "../../../../main-C3-4ZYQP.mjs";
import "../../../../index.es-YI5dIElQ.mjs";
import "../../ColumnCustom/ColumnSort/ColumnSortList.js";
import "../../../../table-XsUAem3c.mjs";
import "../../../../style-pk1ekFUy.mjs";
import "../../BulkAction/style.js";
import "../style.js";
import "../../style.js";
import "../../../Tree/style.js";
import "../../../UI/FormArea/FormFooter.js";
import "../../../css.js";
function A(m) {
  const {
    total: i,
    range: t
  } = m, p = /* @__PURE__ */ o.jsx(r.Text, { fs: "12", children: `Total ${i} items` }), n = t != null && t.length ? /* @__PURE__ */ o.jsx(r.Text, { fs: "12", children: `${t[0]} - ${t[1]} of ${i}` }) : null;
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: t != null && t.length ? n : p });
}
export {
  A as PaginationTitle
};
//# sourceMappingURL=PaginationTitle.js.map
